import { MailIcon, CloseIcon, SendIcon } from "./icons";

export default function MailModal({ open, isFollowup, mail, sending, loading, onChange, onCancel, onSend }) {
  if (!open) return null;
  return (
    <div className="overlay overlay--mail" onClick={(e) => e.target === e.currentTarget && onCancel()}>
      <div className="mail-box">
        <div className="mail-box__head">
          <span className="sheet-box__icon">
            <MailIcon />
          </span>
          <span className="sheet-box__titles">
            <span className="sheet-box__title">{isFollowup ? "Follow-up reminder" : "Send to bank"}</span>
            <span className="sheet-box__sub">
              {isFollowup ? "Reminder emailed if there is no response yet" : "Review the email sent with the attached documents"}
            </span>
          </span>
          <button type="button" className="sheet-box__close" onClick={onCancel}>
            <CloseIcon />
          </button>
        </div>
        <div className="mail-box__body">
          <div className="mail-box__grid">
            <label>
              <span className="mail-box__field-label">To</span>
              <input className="mail-box__input" value={mail.to} onChange={(e) => onChange("to", e.target.value)} />
            </label>
            <label>
              <span className="mail-box__field-label">CC</span>
              <input className="mail-box__input" value={mail.cc} onChange={(e) => onChange("cc", e.target.value)} />
            </label>
          </div>
          <label>
            <span className="mail-box__field-label">Subject</span>
            <input className="mail-box__input" value={mail.subject} onChange={(e) => onChange("subject", e.target.value)} />
          </label>
          <label>
            <span className="mail-box__field-label">Message</span>
            <textarea
              className="mail-box__textarea"
              rows={9}
              placeholder={loading ? "Loading template…" : ""}
              value={mail.body}
              onChange={(e) => onChange("body", e.target.value)}
            />
          </label>
          {isFollowup ? (
            <>
              <label>
                <span className="mail-box__field-label">Follow-up date</span>
                <input
                  type="date"
                  className="mail-box__input"
                  value={mail.followUpDate || ""}
                  onChange={(e) => onChange("followUpDate", e.target.value)}
                />
              </label>
              <label>
                <span className="mail-box__field-label">Follow-up remark</span>
                <input
                  className="mail-box__input"
                  value={mail.followUpRemark || ""}
                  onChange={(e) => onChange("followUpRemark", e.target.value)}
                />
              </label>
            </>
          ) : (
            <>
              <label>
                <span className="mail-box__field-label">Endorsement date</span>
                <input
                  type="date"
                  className="mail-box__input"
                  value={mail.endorsementDate || ""}
                  onChange={(e) => onChange("endorsementDate", e.target.value)}
                />
              </label>
              <label>
                <span className="mail-box__field-label">Remark</span>
                <input className="mail-box__input" value={mail.remark || ""} onChange={(e) => onChange("remark", e.target.value)} />
              </label>
            </>
          )}
        </div>
        <div className="mail-box__foot">
          <button type="button" className="mail-box__cancel" onClick={onCancel}>
            Cancel
          </button>
          <button type="button" className="mail-box__send" onClick={onSend} disabled={sending || loading}>
            <SendIcon size={15} stroke="#fff" />
            {sending ? "Sending…" : isFollowup ? "Send reminder" : "Send to bank"}
          </button>
        </div>
      </div>
    </div>
  );
}
